// It is safe to use these components here, because they are available in both
// consumer apps, and the conditional export ensures the right one is used.
import isNewConsumerApp from 'commons/isNewConsumerApp';
import ProductGridNewConsumerApp from './components/ProductGrid/ProductGridNewConsumerApp';
import ProductGridOldConsumerApp from './components/ProductGrid/ProductGridOldConsumerApp';

const ProductGrid = isNewConsumerApp
  ? ProductGridNewConsumerApp
  : ProductGridOldConsumerApp;

export default ProductGrid;
